import React from 'react';
import { Outlet } from 'react-router-dom';
import ActiveSimulation from './active-simulation/ActiveSimulation';
import LoadingSimulation from './active-simulation/LoadingSimulation';
import { useSignalRActiveClassroom, useSignalRActiveSimulation } from './active-simulation/useActiveSimulation';
import ClassroomError from './classroom-error/ClassroomError';
import JoinClassroom from './join-classroom/JoinClassroom';
import ReturnToClassroom from './return-to-classroom/ReturnToClassroom';

const App = () => {
  useSignalRActiveSimulation();
  useSignalRActiveClassroom();

  return (
    <>
      <Outlet />
      <LoadingSimulation />
      <ActiveSimulation />
      <ReturnToClassroom />
      <JoinClassroom />
      <ClassroomError />
    </>
  );
};

export default App;
